import { useQuery, useQueryClient, useMutation } from "react-query";
import { fetchWallets, addWallet, editWallet, deleteWallet, uploadToWallet } from "../helpers/api";
import { checkUserAuthorizedQuery } from 'helpers/current-user';

export const useWallets = () => {
  const query = useQuery(["get-wallets"], fetchWallets, {select: (data) => data,});
  checkUserAuthorizedQuery(query);
  return query;
};

export const useAddWallet = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["add-wallet"], {
    mutationFn: (data) => addWallet(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
      setTimeout(function() {
        queryClient.invalidateQueries(['get-wallets']);
      }, 500);
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["add-wallet"]);
};

export const useEditWallet = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["edit-wallet"], {
    mutationFn: (data) => editWallet(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
      setTimeout(function() {
        queryClient.invalidateQueries(['get-wallets']);
      }, 500);
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["edit-wallet"]);
};

export const useDeleteWallet = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["delete-wallet"], {
    mutationFn: (data) => deleteWallet(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
      queryClient.invalidateQueries(['get-wallets']);
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["delete-wallet"]);
};


export const useUploadToWallet = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["upload-wallet"], {
    mutationFn: (data) => uploadToWallet(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["upload-wallet"]);
};